<template>
  <content-box class="change-plan--wrap" :width="'970px'">
    <div class="modal-container">

      <div class="modal">
        <div class="modal-close" @click="onCloseLayer"></div>
        <div class="modal-header">{{ $t('userInfo.managePlan.changePlan.option.title') }}</div>
        <div class="modal-body">
          <div class="step-by-price-area">
            <template v-for="(step, index) in steps">
              <div class="step-wrap" :class="`step_${index + 1}`" :key="index">
                <div class="step-title" :data-num="index + 1">{{ step.title }}</div>
                <div class="step-contents">
                  <div class="content-card left" :class="{selected: isSelected(index), disabled: isDisabled(index)}"
                       @click="!isDisabled(index) && checkOption(index, 'type1')">
                    <div class="content-card-title">{{ step.options.type1.main }}</div>
                    <div class="content-card-detail">
                      <div class="item">{{ step.options.type1.detail[0] }}</div>
                    </div>
                    <div class="content-card-check"></div>
                  </div>
                  <div class="content-card right" :class="{selected: !isSelected(index)}"
                       @click="checkOption(index, 'type2')">
                    <div class="content-card-title" :class="{ja: $i18n.locale === 'ja'}">
                      {{ step.options.type2.main }}
<!--                      <i class="icon icon&#45;&#45;beta" v-if="index === 0"></i>-->
                    </div>
                    <div class="content-card-detail">
                      <template v-if="step.options.type2.detail.length > 1">
                        <div class="item">
                          <span>{{ step.options.type2.detail[0] }}</span>
                          <div class="tooltip-container">
                            <i class="link-icon"></i>
                            <div class="tooltip" >
                              <i class="arrow"></i>
                              <div class="tooltip-content">
                                <p class="tooltip-text" v-html="$t('userInfo.managePlan.changePlan.option.tooltip.text1')"></p>
                                <p class="tooltip-text">{{ $t('userInfo.managePlan.changePlan.option.tooltip.text2') }}</p>
                                <a :href="tooltipLink" class="tooltip-link" target="_blank">
                                  {{ $t('userInfo.managePlan.changePlan.option.tooltip.viewLink') }}
                                  <i class="icon icon-link"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="item">
                          <span>{{ step.options.type2.detail[1] }}</span>
                        </div>
                        <div class="item coming-soon">
                          <span>{{ step.options.type2.detail[2] }}</span>
<!--                          <div class="label-btn">Comming Soon</div>-->
                        </div>
                      </template>
                      <template v-else>
                        <div class="item">
                          {{ step.options.type2.detail[0] }}
                          <span v-if="planType === 'saas' && step.options.type2.sub" class="sub-info">({{ step.options.type2.sub }})</span>
                        </div>
                      </template>
                    </div>
                    <div class="content-card-check"></div>
                  </div>
                </div>
              </div>

            </template>
            <div class="step-wrap referral">
              <div class="referral-title">
                <i class="icon icon--star-badge size-26"></i>
                <p>{{ $t('referral.referralCode') }} {{ $t('common.options') }}</p>
                <p class="referral-benefit">{{ $t('userInfo.managePlan.referral.benefit') }}</p>
              </div>
              <div v-if="currentReferralCode && useCurrentReferralCode && nextReferral" class="referral-current" >
                <p>{{ currentReferralCode }}</p>
                <button @click="useCurrentReferralCode = false">
                  <i class="icon icon--close14"></i>
                </button>
              </div>
              <template v-else>
                <div class="referral-code" ref="referralCodeInputRef">
                  <ui-input-text :type="'text'"
                                 :id="'newReferralCode'"
                                 :placeholder="$t('common.placeHolder.enterReferralCode')"
                                 :modelError="referralCodeError"
                                 :modelValue="newReferralCode"
                                 @input="onReferralCodeInput"
                                 @onFocus="referralCodeError = ''">
                  </ui-input-text>
                  <template v-if="heatmapReferralCode !== nextReferral">
                    <button :class="['get-code-button', { 'disabled': gotHeatmapReferralCode }]" :disabled="gotHeatmapReferralCode" @click="getHeatmapReferralCode">
                      <i class="icon icon--arrow-left-blue"></i>
                      <p>Journey Map {{ $t('referral.getCode') }}</p>
                    </button>
                  </template>
                </div>
                <div v-if="isReferralTermRequired" class="referral-term" ref="referralTermRef">
                  <div class="referral-term-header">
                    <ui-checkbox :value="isReferralTermAgreed" @input="onChangeReferralTermAgreed">
                    </ui-checkbox>
                    <p class="term-title">
                      <a class="link" :href="referralTermLink" target="_blank">{{ $t('referral.register.term.title') }}</a>
                      <span class="necessary">{{ $t('referral.register.term.sub') }}</span>
                    </p>
                    <button :class="['term-toggle', { 'opened': isReferralTermOpened }]" @click="isReferralTermOpened = !isReferralTermOpened">
                      <i class="icon icon--arrow-dropdown"></i>
                    </button>
                    <p v-show="isReferralTermError" class="term-error">
                      {{ $t('common.validationErrorText.referralTerm') }}
                    </p>
                  </div>
                  <ul v-show="isReferralTermOpened" class="term-list">
                    <li v-html="$t('referral.register.term.1')"></li>
                    <li v-html="$t('referral.register.term.2')"></li>
                    <li v-html="$t('referral.register.term.3')"></li>
                  </ul>
                </div>
              </template>
            </div>
          </div>
          <div class="total-price-area">
            <div class="plan-name-wrap">
              <div class="plan-name">{{ selectionStates[0].type2 ? plusPlanName : newPlanName }} {{ $t('plan.plan') }}</div>
              <div class="plan-detail">{{ newPlanPv | thousand }} PV / {{ $t('plan.pricing.month') }}</div>
            </div>
            <div class="plan-info-wrap">
              <div class="item">
                <span>{{ $t('plan.pricing.planFee') }}</span>
                <div class="frame">
                  {{ regularPrice | thousand }}{{ $t('plan.pricing.currencyUnit')}}
                </div>
              </div>
              <template>
                <div class="item" v-if="planType === 'enterprise'">
                  <span>{{ $t('plan.pricing.basicDiscount') }}</span>
                  <div class="frame">
                    {{ $t('plan.pricing.basicPlusDiscount') }}
                  </div>
                </div>
              </template>
              <div class="item" v-if="selectionStates[1].type2 && this.newPlanName !== 'Starter'">
                <span>{{ $t('plan.pricing.annualDiscount') }}</span>
                <div class="frame">
                  {{ $t('plan.pricing.tenPercentDiscount') }}
                </div>
              </div>
              <div class="item" v-if="referralCode">
                <span>{{ $t('plan.pricing.referralDiscount') }}</span>
                <div class="frame">
                  {{ $t('plan.pricing.tenPercentDiscount') }}
                </div>
              </div>
            </div>
            <div class="plan-total-wrap">
              <div class="total-price">{{ totalFee | thousand }}{{ $t('plan.pricing.currencyUnit') }}</div>
              <div class="price-per-month">{{ $t('plan.pricing.monthlyFee') }} {{ monthlyFee | thousand}}{{ $t('plan.pricing.currencyUnit') }}({{ $t('common.vat') }})</div>
              <div class="price-btn-wrap">
                <div class="plan-prev-btn" @click="goPrevStep">
                  <i class="icon icon--arrow-left-black"></i>
                  {{ $t('funnel.sessionReport.prev')}}
                </div>
                <div class="plan-apply-btn"
                     @click="onPayment()"
                     v-if="setApplyState">
                     {{ $t('common.confirm') }}
                </div>
                <div class="plan-apply-btn" @click="onSelectPlan(planType)" v-else>{{ $t('plan.pricing.enterprise.contactUs') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </content-box>
</template>
<script>
import { getCurrentNext } from '@/api/userPlan'
import { checkReferExist, checkReferValidate } from '@/api/referral'

import { openContactUs, thousand } from '@/libs/utils'
import { getNormalPlanData, normalPlans } from '@/libs/plan-helper'
import { IS_PRODUCTION } from '@/libs/constants'

import ContentBox from '@/components/ui/ContentBox'
import UiInputText from '@/components/ui/UiInputText'
import UiCheckbox from '@/components/ui/UiCheckbox'

export default {
  components: {
    ContentBox,
    UiInputText,
    UiCheckbox
  },
  props: [
    'userData',
    'planData',
    'newPlanData',
    'nextReferral',
    'paymentType',
    'planType'
  ],
  data () {
    return {
      hasTermsError: false,
      isTermsAgree: false,
      showPlanList: false,
      steps: [
        {
          title: this.$t('userInfo.managePlan.changePlan.option.type1.title'),
          options: {
            type1: {
              main: this.$t('userInfo.managePlan.changePlan.option.type1.main'),
              detail: [this.$t('userInfo.managePlan.changePlan.option.type1.detail')]
            },
            type2: {
              main: this.$t('userInfo.managePlan.changePlan.option.type1.main2'),
              detail: [
                this.$t('userInfo.managePlan.changePlan.option.type1.detail2.desc'),
                this.$t('userInfo.managePlan.changePlan.option.type1.detail2.desc2'),
                this.$t('userInfo.managePlan.changePlan.option.type1.detail')
              ]
            }
          }
        },
        {
          title: this.$t('userInfo.managePlan.changePlan.option.type2.title'),
          options: {
            type1: {
              main: this.$t('userInfo.managePlan.changePlan.option.type2.main'),
              detail: []
            },
            type2: {
              main: this.$t('userInfo.managePlan.changePlan.option.type2.main2'),
              detail: [
                this.$t('userInfo.managePlan.changePlan.option.type2.detail2')
              ],
              sub: this.$t('userInfo.managePlan.changePlan.option.type2.detailSub')
            }
          }
        },
        {
          title: this.$t('userInfo.managePlan.changePlan.option.type3.title'),
          options: {
            type1: {
              main: this.$t('userInfo.managePlan.changePlan.option.type3.main'),
              detail: [this.$t('userInfo.managePlan.changePlan.option.type3.detail')]
            },
            type2: {
              main: this.$t('userInfo.managePlan.changePlan.option.type3.main2'),
              detail: [
                this.$t('userInfo.managePlan.changePlan.option.type3.detail2')
              ]
            }
          }
        }
      ],
      showTooltip: false,
      isCheckOption: [
        true,
        true,
        !(this.$i18n.locale === 'en' || this.$i18n.locale === 'ja')
      ],
      selectionStates: [],
      newReferralCode: '',
      heatmapReferralCode: '',
      referralCodeError: '',
      useCurrentReferralCode: true,
      isReferralTermRequired: true,
      isReferralTermAgreed: false,
      isReferralTermOpened: true,
      isReferralTermError: false,
      gotHeatmapReferralCode: false,
      lang: this.$i18n.locale,
      currentPlanData: null,
      plusPlanName: null,
      plusPlanPrice: null
    }
  },
  computed: {
    /**
     * 툴팁 링크
     * @returns {string}
     */
    tooltipLink () {
      if (this.lang === 'ko') {
        return 'https://forum.beusable.net/ko/post/1935'
      } else if (this.lang === 'ja') {
        return 'https://forum.beusable.net/ja/post/2132'
      } else {
        return 'https://forum.beusable.net/en/post/2133'
      }
    },
    /**
     * 신규 요금제 이름
     * @returns {string}
     */
    newPlanName () {
      return this.newPlanData.name
    },
    /**
     * 신규 요금제 가격
     * @returns {number}
     */
    newPlanPrice () {
      return this.getPriceByLocale()
    },
    /**
     * 신규 요금제 PV
     * @returns {number}
     */
    newPlanPv () {
      return this.newPlanData.pv
    },
    plusPlan () {
      return getNormalPlanData(this.newPlanData.planNumber + 4000)
    },
    /**
     * 총 요금
     * @returns {number}
     */
    totalFee () {
      const basic = this.selectionStates[0].type1 && this.selectionStates[1].type1 && this.selectionStates[2].type1
      const isEnterprise = this.planType === 'enterprise'
      const isAnnual = this.selectionStates[1].type2
      let price = this.getPriceByLocale()

      if (this.referralCode) price *= 0.9

      if (isEnterprise && basic) {
        if (this.lang === 'en' || this.lang === 'ja') {
          return price
        } else {
          price *= 0.9
        }
      } else if (isAnnual) {
        if (isEnterprise) {
          price = ((price * 0.9) * 12) * 0.9
        } else if (this.newPlanName !== 'Starter') {
          price *= 12 * 0.9
        } else {
          price *= 12
        }
      } else if (isEnterprise) {
        price *= 0.9
      }
      return price
    },
    /**
     * 월 요금
     * @returns {number}
     */
    monthlyFee () {
      if (this.selectionStates[1].type1) {
        return this.totalFee
      } else {
        return this.totalFee / 12
      }
    },
    regularPrice () {
      const isAnnual = this.selectionStates[1].type2
      const pirce = this.getPriceByLocale()
      if (isAnnual) {
        return pirce * 12
      }
      return pirce
    },
    /**
     * 선택된 항목
     * @returns {Array}
     */
    selectedItems () {
      return this.steps.filter((step, index) => {
        // 현재 step에서 type1 또는 type2가 선택되었는지 확인
        return this.selectionStates[index].type1 || this.selectionStates[index].type2
      }).map((step, index) => {
        // 선택된 항목의 상세 정보를 포함하는 객체 생성
        const selectedType = this.selectionStates[index].type1 ? 'type1' : 'type2'
        if (this.selectionStates[2].type1) {
          this.$emit('onPaymentTypeChange', 'card')
        }
        return {
          title: step.title,
          main: step.options[selectedType].main,
          details: step.options[selectedType].detail
        }
      })
    },
    useCoupon () {
      return this.planData.useCoupon
    },
    isNew () {
      return this.planData.canCreate
    },
    isUpgrade () {
      return !this.isNew && this.planData.pv < this.newPlanData.pv
    },
    isDowngrade () {
      return !this.isNew && !this.isUpgrade
    },
    setApplyState () {
      const useSelectState = this.planType === 'saas' && this.selectionStates[1].type1 && this.selectionStates[2].type1
      const isAdmin = this.currnetPlan && (this.currnetPlan.applyType === 'admin' && (this.currnetPlan.planName === 'Terminate' || this.currnetPlan.planNAme === 'TrialOver'))
      return useSelectState && !isAdmin
    },
    currentReferralCode () {
      if (this.nextReferral !== null && this.nextReferral.length === 0) {
        return null
      }
      return this.nextReferral ? this.nextReferral : this.currentPlanData && this.currentPlanData.referral
    },
    referralCode () {
      if (this.currentReferralCode && this.useCurrentReferralCode) {
        return this.currentReferralCode
      }
      return this.newReferralCode
    },
    referralTermLink () {
      return `${process.env.VUE_APP_HOME_URL}/${this.$i18n.locale}/referralTerms`
    }
  },
  created () {
    const isLocaleEnOrJa = this.$i18n.locale === 'en' || this.$i18n.locale === 'ja'
    this.selectionStates = [
      { type1: true, type2: false }, // Step 1
      { type1: true, type2: false }, // Step 2
      { type1: !isLocaleEnOrJa, type2: false }
    ]
    getCurrentNext().then(res => {
      this.currentPlanData = res.currentPlan
    })

    checkReferExist({ userId: this.userData.userId, serviceType: 'beusable' })
      .then(res => {
        this.heatmapReferralCode = res.referral
        this.isReferralTermRequired = !res.terms
      })
      .catch(e => {
        console.error(e)
      })
  },
  methods: {
    /**
     * 요금제 변경 옵션 선택
     * @param {number} index
     * @param {string} type
     */
    checkOption (index, type) {
      if (!this.isDisabled(index)) {
        if (type === 'type1') {
          this.selectionStates[index].type1 = true
          this.selectionStates[index].type2 = false
        } else if (type === 'type2') {
          this.selectionStates[index].type1 = false
          this.selectionStates[index].type2 = true
          this.plusPlanName = this.plusPlan.name
          this.plusPlanPrice = this.plusPlan.price
          this.getPriceByLocale()
        }
      }
    },
    /**
     * 이전 단계로 이동
     */
    goPrevStep () {
      this.onCloseLayer()
      this.$emit('onChangePlan', true)
    },
    /**
     * 모달 닫기
     */
    onCloseLayer () {
      this.$emit('closeLayer')
    },
    /**
     * 요금제 선택
     * @param {string} value
     */
    async onSelectPlan (value) {
      if (await this.hasReferralError()) return

      this.selectionStates[2].type2 = true
      if (value === 'enterprise' || this.selectionStates[2].type2 || this.$i18n.locale !== 'ko') {
        if (value === 'enterprise' || this.selectionStates[2].type2) {
          const selectedPlan = this.selectionStates[0].type2 ? normalPlans.find(e => e.planNumber === this.newPlanData.planNumber + 4000) : normalPlans.find(e => e.planNumber === this.newPlanData.planNumber)
          openContactUs(this.userData,
            this.planData.canCreate
              ? this.$t('userInfo.managePlan.default.wireForm', {
                product: selectedPlan.name,
                payments: this.selectionStates[2].type1 ? this.$t('userInfo.managePlan.changePlan.option.type3.main') : this.$t('userInfo.managePlan.changePlan.option.type3.main2'),
                isPlusPlan: this.selectionStates[0].type2 ? this.$t('userInfo.managePlan.default.answer.yes') : this.$t('userInfo.managePlan.default.answer.no'),
                period: this.selectedItems[1].main,
                amount: 1,
                pv: thousand(selectedPlan.pv),
                referral: this.referralCode ? `${this.$t('referral.referralCode')}: ${this.referralCode}\n\n` : '',
                price: thousand(this.totalFee)
              })
              : this.$t('userInfo.managePlan.default.wireFormWithCategory', {
                category: this.$t('common.changePlan'),
                product: selectedPlan.name,
                payments: this.selectionStates[2].type1 ? this.$t('userInfo.managePlan.changePlan.option.type3.main') : this.$t('userInfo.managePlan.changePlan.option.type3.main2'),
                isPlusPlan: this.selectionStates[0].type2 ? this.$t('userInfo.managePlan.default.answer.yes') : this.$t('userInfo.managePlan.default.answer.no'),
                period: this.selectedItems[1].main,
                amount: 1,
                pv: thousand(selectedPlan.pv),
                referral: this.referralCode ? `${this.$t('referral.referralCode')}: ${this.referralCode}\n\n` : '',
                price: thousand(this.totalFee)
              }), true, this.$i18n.locale)
          this.onCloseLayer()
          return false
        }
      }
    },
    async hasReferralError () {
      if (!this.referralCode) {
        if (this.isReferralTermAgreed && !this.newReferralCode) {
          this.referralCodeError = 'requiredReferralCode'
          this.$refs.referralCodeInputRef.scrollIntoView({ behavior: 'smooth' })
          return true
        }
        this.$refs.referralCodeInputRef.scrollIntoView({ behavior: 'smooth' })
        return false
      }
      let hasError = false
      let isReferralCodeValid = null
      await checkReferValidate({ referral: this.referralCode, userId: this.userData.userId })
        .then(res => {
          isReferralCodeValid = res
        })
        .catch(e => {
          console.error(e)
        })

      if (!isReferralCodeValid) {
        this.referralCodeError = isReferralCodeValid === false
          ? 'duplicatedReferralCode'
          : 'invalidReferralCode'
        hasError = true
        this.$refs.referralCodeInputRef.scrollIntoView({ behavior: 'smooth' })
      }
      if (this.newReferralCode && this.isReferralTermRequired && !this.isReferralTermAgreed && !this.userData.referral) {
        this.isReferralTermError = true
        hasError = true
        this.$refs.referralTermRef.scrollIntoView({ behavior: 'smooth' })
      }

      return hasError
    },
    /**
     * 선태한 항목
     */
    isSelected (index) {
      return this.selectionStates[index].type1
    },
    /**
     * 비활성화 여부
     */
    isDisabled (index) {
      const isLastIndex = index === this.steps.length - 1
      return (isLastIndex && this.lang === 'en') || (isLastIndex && this.lang === 'ja')
    },
    async onPayment () {
      if (await this.hasReferralError()) return
      const referralCode = this.currentReferralCode && !this.nextReferral ? null : this.referralCode

      this.$emit('onPayments', true, this.selectionStates, referralCode)
      this.$emit('onPlanNumberChange',
        this.selectionStates[2].type1 ? 'card' : 'wireTransfer',
        this.selectionStates[0].type2 ? this.newPlanData.planNumber + 4000 : this.newPlanData.planNumber
      )
    },
    /**
     * 신규 요금제 다국어 가격
     * @returns {number}
     */
    getPriceByLocale () {
      const lang = this.lang
      const prices = this.selectionStates[0].type2 ? this.plusPlan : this.newPlanData
      if (lang === 'en') return prices.enPrice
      if (lang === 'ja') return prices.jaPrice
      return prices.price
    },
    onChangeReferralTermAgreed (value) {
      this.isReferralTermAgreed = value
      this.isReferralTermError = false
    },
    onReferralCodeInput (e) {
      this.newReferralCode = e || ''
      if (this.gotHeatmapReferralCode) {
        this.gotHeatmapReferralCode = false
      }
    },
    getHeatmapReferralCode () {
      this.newReferralCode = this.heatmapReferralCode
      this.gotHeatmapReferralCode = true
    }
  }
}
</script>

<style lang="scss" >
html[lang="en"] {
  body {
    .change-plan--wrap{
      .modal-container {
      }
    }
  }
}

.change-plan--wrap {
  height: 660px;
  .modal-container {
    position: relative;
    z-index: 0;
    min-width: 200px;
    min-height: 200px;
    border-radius: 1em;
    overflow: hidden;
    box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.16), 0px 0px 0px 1px rgba(0, 0, 0, 0.16);
    transition: all 500ms ease;

    .modal {
      position: relative;
      background-color: #fff;
      width: 970px;
      height: 660px;
      z-index: 0;
      .modal-close {
        cursor: pointer;
        position: absolute;
        top: 12px;
        right: 12px;
        width: 16px;
        height: 16px;
        background: no-repeat center/100% url("https://dream-cdn.beusable.net/home/images/bridge/icon-close.svg");
        z-index: 100;
        transition: all .3s;

        &:hover {
          transform: scale(1.3);
        }
      }
      .modal-header {
        position: absolute;
        width: 100%;
        padding: 30px;
        box-sizing: border-box;
        font-size: 15px;
        font-weight: 500;
        color: #2F2F2F;
        background: linear-gradient(180deg, #FFF 69.77%, rgba(255, 255, 255, 0.00) 100%);
        z-index: 10;
      }
      .modal-body {
        display: flex;
        flex-direction: column;
        height: 100%;
        .total-price-area {
          color: #2f2f2f;
          box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.16), 0px 0px 0px 1px rgba(0, 0, 0, 0.16);
          flex-shrink: 0;
          display: flex;
          padding: 22px 30px;
          .plan {
            &-name-wrap {
              .plan-name {
                font-size: 30px;
                font-weight: 600;
                line-height: 1;
                margin-bottom: 10px;
              }
              .plan-detail {
                color: #444;
                font-size: 13px;
                font-weight: 600;
              }
            }
            &-info-wrap {
              flex-grow: 1;
              display: flex;
              flex-direction: column;
              align-items: center;
              gap: 10px;
              .item {
                position: relative;
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 369px;
                font-size: 13px;
                font-weight: 600;
                line-height: 1.15;
                color: #444;
                z-index: 1;
                &:before {
                  content: '';
                  position: absolute;
                  top: 50%;
                  transform: translateY(0%);
                  left: 0;
                  z-index: -1;
                  width: 90%;
                  // height: 1px;
                  margin: 0 9px;
                  // border-top: 1px dashed #D7D7D7;
                  height: 1px;
                  background-image: linear-gradient(to right,transparent 50%, #D7D7D7 50%);
                  background-size: 5px 1px;
                }
                span {
                  background-color: #fff;
                  padding-right: 4px
                }
                .frame {
                  background-color: #fff;
                  padding-left: 4px;
                }
              }
            }
            &-total-wrap {
              text-align: right;
              .total-price {
                font-size: 26px;
                font-weight: 600;
                margin-bottom: 10px;
              }
              .price-per-month {
                color: #444;
                font-size: 13px;
                font-weight: 500;
                line-height: 1.5;
                margin-bottom: 10px;
              }
              .price-btn-wrap {
                display: flex;
                align-items: center;
                gap: 5px;
                .plan-prev-btn {
                  cursor: pointer;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  gap: 6px;
                  min-width: 90px;
                  box-sizing: border-box;
                  padding: 10px 18px;
                  border: 1px solid #bbb;
                  border-radius: 20px;
                  background-color: #fff;
                  font-size: 14px;
                  font-weight: 600;
                  color: #444;
                  line-height: 1;
                }
                .plan-apply-btn {
                  cursor: pointer;
                  display: inline-flex;
                  justify-content: center;
                  align-items: center;
                  box-sizing: border-box;
                  min-width: 124px;
                  padding: 12px 14px;
                  border-radius: 20px;
                  background-color: #ec0047;
                  font-size: 14px;
                  font-weight: 600;
                  line-height: 1;
                  color: #fff;
                }
              }
            }
          }
        }
        .step-by-price-area {
          flex-grow: 1;
          overflow-y: auto;
          padding: 30px;
          margin-top: 45px;
          .step-wrap {
            padding: 20px 40px;
            border-top: 1px dashed #D7D7D7;
            .step-title{
              position: relative;
              color: #2F2F2F;
              font-size: 15px;
              padding: 7px 0 8px;
              &:before {
                content: attr(data-num);
                position: absolute;
                top: 50%;
                right: 100%;
                transform: translate(-10px, -50%);
                width: 30px;
                height: 30px;
                color: #666;
                font-size: 16px;
                border: 1px solid #D7D7D7;
                border-radius: 50%;
                padding: 6px;
                box-sizing: border-box;
                text-align: center;
              }
            }
            .step-contents {
              display: flex;
              justify-content: center;
              gap: 20px;
              padding: 20px 0;
              .content-card {
                cursor: pointer;
                position: relative;
                width: 50%;
                flex-grow: 1;
                padding: 24px;
                border: 1px solid #AFAFAF;
                border-radius: 8px;
                color: #2F2F2F;
                min-height: 130px;
                box-sizing: border-box;
                isolation: isolate;
                .content-card-title {
                  font-size: 24px;
                  font-weight: 600;
                  line-height: 1;
                  margin-bottom: 18px;
                  max-width: 312px;

                  &.ja {
                    max-width: 310px;
                  }

                  .icon.icon--beta {
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: 100% 100%;
                  }
                }
                .content-card-detail {
                  font-size: 13px;
                  font-weight: 400;
                  line-height: 1;
                  display: flex;
                  flex-direction: column;
                  gap: 12px;
                  .item {
                    display: flex;
                    align-items: center;
                    gap: 5px;
                    span {
                      line-height: 1;
                    }
                    span.sub-info {
                      color: #767676;
                    }
                    &.coming-soon {
                      color: #2f2f2f;
                    }
                    .label-btn {
                      color: #BBB;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      font-size: 7px;
                      line-height: 7px;
                      border: 1px solid #BBBBBB;
                      border-radius: 4px;
                      padding: 3px 5px 2px;
                      letter-spacing: .1px;
                    }

                    .tooltip-container {
                      position: relative;
                      i.link-icon {
                        position: relative;
                        display: inline-block;
                        width: 15px;
                        height: 15px;
                        background: url("https://dream-cdn.beusable.net/home/images/icon-info.svg") no-repeat center center;
                        background-size: cover;
                      }

                      .tooltip {
                        // min-width: 225px;
                        // min-height: 122px;
                        max-width: 285px;
                        width : 285px;
                        position: absolute;
                        top: 25px;
                        left: 50%;
                        transform: translateX(-50%);
                        z-index: 5;
                        border-radius: 8px;
                        box-shadow: 0px 23px 15px -12px rgba(0, 0, 0, 0.08), 0px 0px 0px 1px rgba(0, 0, 0, 0.08);
                        background-color: #ffffff;
                        padding: 16px 20px;
                        box-sizing: border-box;
                        opacity: 1;
                        transition: all .3s;
                        display: none;

                        .arrow {
                          content: '';
                          background-color: #fff;
                          position: absolute;
                          z-index: 2;
                          width: 10px;
                          height: 10px;
                          box-shadow: 1px -1px 0 0 rgba(0, 0, 0, 0.16);
                          top: -8px;
                          left: 50%;
                          transform: rotate(-45deg) translateX(-50%);
                        }

                        .tooltip-content {
                          .tooltip-text {
                            font-size: 13px;
                            line-height: 1.2;
                            font-weight: 400;
                            color: #444;
                            margin-bottom: 10px;
                          }
                          .tooltip-link {
                            display: flex;
                            align-items: center;
                            font-size: 13px;
                            font-weight: 400;
                            color: #0074FF;
                            text-decoration: none;
                            margin-top: 10px;
                            i.icon-link {
                              width: 16px;
                              height: 16px;
                              background: url('../../../assets/img/icon_link_blue_size16.svg') no-repeat center center;
                              background-size: cover;
                              transform: scaleX(-1);
                              margin-left: 5px;
                            }
                          }
                        }
                        &:lang(en) {
                          transform: translateX(-70%);
                          .arrow {
                              left: 70%;
                          }
                        }
                      }

                      &:hover .tooltip {
                        display: block;
                      }
                    }
                  }
                }
                &.selected {
                  // outline: 2px solid #4497F7;
                  border-color: #4497F7;
                  box-shadow:
                  0px 0px 0px 1px #4497F7 inset,
                  0px 11px 17px -3px rgba(0, 0, 0, 0.16);
                  .content-card-check {
                    position: absolute;
                    top: 24px;
                    right: 24px;
                    width: 20px;
                    height: 20px;
                    background: url("https://dream-cdn.beusable.net/home/images/icon-check-green.svg") no-repeat center center;
                    background-size: cover;
                  }
                }

                &.disabled {
                  pointer-events: none;
                  opacity: 0.5;
                }
              }
            }
            &:first-child {
              border: 0;
              padding-top: 0;
            }

            &.referral {
              padding: 30px 0 6px;
              text-align: left;
              .referral-title {
                @include flexYcenter;
                margin-bottom: 18px;
                gap: 6px;
                color: #2F2F2F;
                font-size: 15px;
                font-weight: 600;
                .referral-benefit {
                  position: relative;
                  margin-left: 23px;
                  color: #777;
                  font-size: 12px;
                  font-weight: 400;
                  &:before {
                    content: '';
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    left: -12px;
                    width: 1px;
                    height: 12px;
                    background-color: #D7D7D7;
                  }
                }
              }
              .referral-current {
                display: inline-flex;
                align-items: center;
                height: 28px;
                padding: 0 8px 0 10px;
                gap: 4px;
                color: #0E90A5;
                font-size: 12px;
                font-weight: 600;
                border-radius: 4px;
                border: 1px solid #BBB;
                button {
                  display: flex;
                }
              }
              .referral-code {
                @include flexYcenter;
                gap: 20px;

                .input--wrap {
                  width: 287px;
                  margin: 0;
                  .label {
                    display: none;
                  }
                }
                .get-code-button {
                  @include flexYcenter;
                  gap: 4px;
                  color: #0E90A5;
                  font-size: 13px;
                  &.disabled {
                    pointer-events: none;
                    opacity: .2;
                  }
                }
              }

              .referral-term {
                position: relative;
                &-header {
                  @include flexYcenter;
                  margin-top: 32px;

                  .ui_checkbox {
                    margin: 0;
                  }
                  .term-title {
                    color: #2F2F2F;
                    font-size: 13px;
                    font-weight: 400;
                    line-height: 120%;
                    .link {
                      text-decoration: underline;
                      color: #2F2F2F;
                    }
                    .necessary {
                      color: $brandColor;
                    }
                  }
                  .term-toggle {
                    display: flex;
                    margin-left: 8px;
                    &.opened {
                      .icon {
                        transform: rotate(180deg);
                      }
                    }
                  }

                  .term-error {
                    color: #E60724;
                    font-size: 12px;
                    font-weight: 500;
                    line-height: 1.5;
                    margin-left: 24px;
                  }
                }
                .term-list {
                  display: flex;
                  flex-direction: column;
                  gap: 4px;
                  padding: 20px 20px 20px 30px;
                  margin-top: 12px;
                  border-radius: 5px;
                  border: 1px solid #d7d7d7;
                  background-color: #f4f4f4;
                  box-sizing: border-box;
                  color: #444;
                  font-size: 12px;
                  line-height: 1.5;
                  list-style-type: disc;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
